import {VisitDocumentService} from '../../../services/visitDocumentService';
import {createEntityThunks} from '../../../utils/createEntityThunks';
import {VisitDocument} from '../../../types/visitDocument';

const VisitDocumentFactory = (data: any) => new VisitDocument(data);

export const VisitDocumentThunks = createEntityThunks<VisitDocument>(
  'visitDocument',
  VisitDocumentService,
  {activate: false, deactivate: false},
  VisitDocumentFactory,
);
